import { useEffect, useState } from "react"
import {
  Box,
  Button,
  Checkbox,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

import {
  DropdownFilterContainer,
  DropdownSearchFilter,
  DropdownWrapper,
  StyledAutoComplete,
  StyledMenuItem,
  StyledSelect,
} from "./Atom"
import { useDispatch } from "react-redux"
import {
  setProvidersMetricTabs,
  setProvidersTableData,
  setSelectedProviderMetrics,
  setSelectedProviders,
  setSelectedProvidersMetricTab,
} from "../../../redux/slices/providersSlice"
import { useSelector } from "react-redux"
import { colors } from "../../../../styles/commonStyles"
import { toast } from "react-toastify"

const ProvidersHeaderProviderDropdownFilter = (props: any) => {
  const dispatch = useDispatch()

  const selectedSpeciality = useSelector((state: any) => {
    return state.providers.selectedSpeciality
  })

  const selectedProviders = useSelector((state: any) => {
    return state.providers.selectedProviders
  })
  const providersList = useSelector((state: any) => {
    return state.providers.providersList
  })
  const selectedProvidersOffices = useSelector((state: any) => {
    return state.providers.selectedProvidersOffices
  })

  const {
    id,
    disabled,
    handleFilter,
    placeholder,
    value,
    filterData,
    headerLabel,
    multiple,
  } = props

  const [selectAllChecked, setSelectAllChecked] = useState<boolean>(false)
  const [checkedMenuItems, setCheckedMenuItems] = useState<Array<number>>([])
  const [filteredFilterData, setFilteredFilterData] = useState<Array<any>>([
    ...filterData,
  ])
  // const [isAllSelected, setIsAllSelected] = useState(true)

  const [flag, setFlag] = useState<boolean>(true)
  const [open, setOpen] = useState(false)

  const handleCheckedMenuItems = (provider: any) => {
    const provider_sk = provider?.provider_sk

    if (checkedMenuItems.includes(provider_sk)) {
      setCheckedMenuItems(
        checkedMenuItems.filter((item: any) => item !== provider_sk),
      )
      dispatch(
        setSelectedProviders(
          selectedProviders.filter(
            (localProvider: any) => localProvider?.provider_sk != provider_sk,
          ),
        ),
      )
      setSelectAllChecked(false)
      dispatch(setProvidersMetricTabs([]))
      dispatch(setSelectedProvidersMetricTab({}))
      dispatch(setProvidersTableData([]))
    } else {
      setCheckedMenuItems([...checkedMenuItems, provider_sk])
      dispatch(setSelectedProviders([...selectedProviders, provider]))
    }
  }

  const onSearchFilterChange = (value: any) => {
    setFlag(false)
    setFilteredFilterData(
      filterData?.filter((item: any) =>
        item?.label?.toLowerCase()?.includes(value?.toLowerCase()),
      ),
    )
  }
  const handleSelectAll = () => {
    if (selectAllChecked) {
      dispatch(setSelectedProviders([]))
      setCheckedMenuItems([])
      dispatch(setProvidersMetricTabs([]))
      dispatch(setProvidersTableData([]))
      dispatch(setSelectedProvidersMetricTab({}))
      dispatch(setSelectedProviderMetrics([]))
    } else {
      const allProviderSk = filterData.map((item: any) => item.provider_sk)
      setCheckedMenuItems(allProviderSk)
      dispatch(setSelectedProviders(filteredFilterData))
    }
    setSelectAllChecked(!selectAllChecked)
  }
  const isAllSelected =
    filteredFilterData?.length > 0 &&
    checkedMenuItems?.length >= filteredFilterData?.length

  useEffect(() => {
    setFilteredFilterData(filterData)
    if (selectedProvidersOffices?.length) {
      setCheckedMenuItems(filterData?.map((ele: any) => ele?.provider_sk))
      dispatch(setSelectedProviders(filterData))
      setSelectAllChecked(!selectAllChecked)
    } else {
      setCheckedMenuItems([])
      dispatch(setSelectedProviders([]))
    }
  }, [filterData])
  useEffect(() => {
    if (checkedMenuItems?.length >= filteredFilterData?.length) {
      setCheckedMenuItems([])
      setSelectAllChecked(!selectAllChecked)
    }
  }, [selectedSpeciality])

  useEffect(() => {
    setSelectAllChecked(false)
    setCheckedMenuItems([])
    if (filterData?.length) {
      setFilteredFilterData(filterData)
    }
  }, [selectedSpeciality, selectedProvidersOffices])

  return (
    <DropdownFilterContainer>
      <Typography fontSize={10}>{headerLabel}</Typography>
      {/* <FormControl> */}
      {/* <InputLabel>Text</InputLabel> */}

      <StyledSelect
        labelId="demo-multiple-name-label"
        // className="styled-scrollbar-vertical-broad"
        id={id}
        multiple={multiple}
        value={value}
        open={open}
        onOpen={() => setOpen(true)}
        // onChange={handleFilter}]
        onClose={() => {
          setOpen(false)
          setFlag(true)
        }}
        disabled={disabled}
        IconComponent={ExpandMoreIcon}
        displayEmpty
        renderValue={(selected: any): any =>
          multiple ? (
            value?.length ? (
              <Box sx={{ overflow: "hidden" }}>
                {selected?.map((item: any, index: any) =>
                  index + 1 == selected?.length
                    ? `${item?.label}`
                    : `${item?.label}, `,
                )}
              </Box>
            ) : (
              <Box>{placeholder}</Box>
            )
          ) : selected ? (
            `${selected?.label}`
          ) : (
            `${placeholder}`
          )
        }
      >
        <DropdownWrapper>
          <Box
            sx={{
              maxHeight: "200px",
              position: "sticky",
              top: "7px",
              zIndex: 1,
              backgroundColor: "#fff",
            }}
          >
            <DropdownSearchFilter>
              <TextField
                //disabled={searchDisable}
                autoFocus
                placeholder="Search..."
                variant="outlined"
                size="small"
                onChange={(e: any) => onSearchFilterChange(e?.target?.value)}
                sx={{
                  backgroundColor: "#fff",
                  width: "180px",
                }}
              />
            </DropdownSearchFilter>
            <Box sx={{ width: "180px", height: "40px", mb: "3px" }}>
              <MenuItem
                onClick={() => handleSelectAll()}
                sx={{
                  width: "100%",
                  borderRadius: "5px",
                  padding: "10px 10px",
                  gap: "10px",
                }}
              >
                <Checkbox
                  name="select-checkbox"
                  checked={isAllSelected}
                  sx={{ p: 0 }}
                />
                Select All
              </MenuItem>
            </Box>
          </Box>
          <Box sx={{ maxHeight: "400px", overflowX: "scroll" }}>
            {filterData?.length && flag ? (
              filterData?.map((item: any) => (
                <StyledMenuItem
                  value={item}
                  disableRipple
                  sx={{
                    width: "180px",
                    gap: "10px",
                    padding: "10px 10px",
                    display: "flex",
                    backgroundColor: checkedMenuItems?.includes(
                      item?.provider_sk,
                    )
                      ? "#dce7fe"
                      : "",
                  }}
                  onClick={() => handleCheckedMenuItems(item)}
                >
                  <Checkbox
                    sx={{ padding: 0 }}
                    checked={checkedMenuItems?.includes(item?.provider_sk)}
                  />
                  <Typography sx={{ marginLeft: "10px" }}>
                    {item?.label}
                  </Typography>
                </StyledMenuItem>
              ))
            ) : filteredFilterData?.length ? (
              filteredFilterData?.map((item: any) => (
                <StyledMenuItem
                  value={item}
                  disableRipple
                  sx={{
                    width: "180px",
                    gap: "10px",
                    padding: "10px 10px",
                    display: "flex",
                    backgroundColor: checkedMenuItems?.includes(
                      item?.provider_sk,
                    )
                      ? "#dce7fe"
                      : "",
                  }}
                  onClick={() => handleCheckedMenuItems(item)}
                >
                  <Checkbox
                    sx={{ padding: 0 }}
                    checked={checkedMenuItems?.includes(item?.provider_sk)}
                  />
                  <Typography sx={{ marginLeft: "10px" }}>
                    {item?.label}
                  </Typography>
                </StyledMenuItem>
              ))
            ) : (
              <StyledMenuItem disabled={true}>No Data</StyledMenuItem>
            )}
          </Box>
          <Box
            sx={{
              position: "sticky",
              bottom: "0px",
              minHeight: "50px",
              backgroundColor: "#fff",
              marginBottom: -1,
              pb: "8px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              fullWidth
              disableFocusRipple
              key={"apply-close"}
              variant="contained"
              onClick={() => {
                setOpen(false)
              }}
              sx={{
                height: "40px",
                width: "175px",
                textTransform: "none",
                fontWeight: "bold",
                justifyContent: "center",

                mt: "5px",
                borderWidth: 0,
                backgroundColor: colors.primaryBlue,
              }}
            >
              Apply
            </Button>
          </Box>
        </DropdownWrapper>
      </StyledSelect>
      {/* </FormControl> */}
    </DropdownFilterContainer>
  )
}

export default ProvidersHeaderProviderDropdownFilter
